var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8634 15.8454V15.8448H15.8671V10.3262C15.8671 7.62651 15.2918 5.54688 12.1674 5.54688C10.6655 5.54688 9.65752 6.37948 9.24603 7.16883H9.20259V5.79891H6.24023V15.8448H9.32485V10.8704C9.32485 9.5607 9.57063 8.29423 11.1762 8.29423C12.7583 8.29423 12.7819 9.78891 12.7819 10.9544V15.8454H15.8634Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09082 5.76953H4.22515V15.6203H1.09082V5.76953Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.65823 0.84375C1.66949 0.84375 0.867188 1.64231 0.867188 2.62644C0.867188 3.61058 1.66949 4.42584 2.65823 4.42584C3.64697 4.42584 4.44928 3.61058 4.44928 2.62644C4.44866 1.64231 3.64635 0.84375 2.65823 0.84375V0.84375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.9077b47ccb67bdc447cf7df3eb50e268.svg";
export { ForwardRef as ReactComponent };